import axios from "../../../../axios.js";
import store from "../../../../store/store.js";
import i18n from "../../../../i18n/i18n";

export default {
  init() {
    axios.interceptors.request.use(
      (config) => {
        config.headers = {
          language: i18n.locale,
          Authorization: "Bearer " + localStorage.getItem("Token"),
        };

        debugger;
        // Do something before request is sent
        store.commit("changeLoadingStatus", true);
        // alert("S");
        return config;
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      (response) => {
        store.commit("changeLoadingStatus", false);

        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      },
      (error) => {
        store.commit("changeLoadingStatus", false);
        if (error.response.status) {
          switch (error.response.status) {
            case 400:
              console.log("Error 400");
              break;
            case 401:
              store.state.SessionExpired = true;
              store.dispatch("auth/logout");
              break;
            case 403:
              console.log("Error 403");
              break;
            case 404:
              console.log("Error 404");
              break;
            case 502:
              console.log("Error 502");
          }
          return Promise.reject(error);
        }
      }
    );
  },
  login(userName, password) {
    return axios.post("/API/Account/Login", {
      userName: userName,
      password: password,
      // UserLanguage: Language,
    });
  },
  registerUser(confPassword, email, pwd) {
    return axios.post("/AdminAccount/RegisterUser", {
      confirmPassword: confPassword,
      email: email,
      password: pwd,
    });
  },
  // refreshToken() {
  //   return axios.post("/refresh", {
  //     refreshToken: localStorage.getItem("refreshToken")
  //   });
  // }
};
